export default __webpack_public_path__ + "static/media/mons.3ad498c8.jpg";